import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDataIngredients } from "./../store/actions";
import { useFormikCustom } from 'core/hooks/useFormikCustom';
import type { TIngredient } from "./../store/types";
import { useOnSelectIngredient } from './useSelectIngredient';

export const useFetchIngredient = () => {
  const dispatch = useDispatch()
  const ingredients = useSelector(
    (state: any) => state.Ingredients.ingredients
  );

  useEffect(() => {
    dispatch(fetchDataIngredients())
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchDataIngredients])

  return ingredients
}

export const useIngredient = (
  ingredients: TIngredient[],
  myIngredients: TIngredient[],
  ingredientSelecting: TIngredient[]
) => {
  const [ingredientFiltered, setIngredients] = useState<TIngredient[]>(
    ingredients
  )

  const formik = useFormikCustom({
    initialValues: {
      name: '',
    },
    onSubmit() {
      //
    },
  });

  useEffect(() => {
    setIngredients(() => 
      ingredients.filter((item: TIngredient) => {
        const name = item.name?.toLowerCase()
        const filterName = formik.values.name?.toLowerCase()
        return name.includes(filterName || '')
      })
    )
  }, [formik.values.name, ingredients])

  const {
    getExistIngredients,
    message,
  } = useOnSelectIngredient(
    myIngredients,
    ingredients,
    ingredientSelecting
  )

  return {
    ingredients: ingredientFiltered,
    formik,

    getExistIngredients,
    message,
  }
}
